import React, {Component} from 'react';
import {Row, Table, Button} from 'antd';

class TaskCorrection extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const columns = [
                {
                    title: '序号',
                    dataIndex: 'xh',
                    key: 'xh',
                    width: '5%',
                    render(text, record, index){
                        return index+1;
                    }
                },
                {
                    title: '任务名称',
                    dataIndex: 'rwmc',
                    key: 'rwmc',
                    width: '20%'
                },
                {
                    title: '任务地点',
                    dataIndex: 'rwdd',
                    key: 'rwdd',
                    width: '20%'
                },
                {
                    title: '执行人数',
                    dataIndex: 'zxrs',
                    key: 'zxrs',
                    width: '10%'
                },
                {
                    title: '危险程度',
                    dataIndex: 'wxcd',
                    key: 'wxcd',
                    width: '10%'
                },
                {
                    title: '执行所用时间',
                    dataIndex: 'zxsysj',
                    key: 'zxsysj',
                    width: '10%'
                },
                {
                    title: '任务日期',
                    dataIndex: 'rwrq',
                    key: 'rwrq',
                    width: '10%'
                },
                {
                    title: '操作',
                    dataIndex: 'cz',
                    key: 'cz',
                    width: '15%',
                    render: (text, record) => {
                        return (
                            <Row type="flex" justify="center">
                                <Button size="small" style={{marginRight: 10}}>查看详情</Button>
                                <Button size="small" style={{marginLeft: 10}}>纠错修正</Button>
                            </Row>
                        )
                    }
                },
            ],
            loading = this.state.data_loding,
            locale = {
                filterTitle: '筛选',
                filterConfirm: '确定',
                filterReset: '重置',
                emptyText: loading ? '正在加载中...' : '暂无报备信息',
            },
            dataSource = [
                {
                    rwmc: '千灯湖捉喵行动',
                    rwdd: '广东省佛山市南海区桂城',
                    zxrs: '4人',
                    zxsysj: '02:42:18',
                    rwrq: '2018-03-30',
                    wxcd: '黄色'
                },{
                    rwmc: '千灯湖捉喵行动',
                    rwdd: '广东省佛山市南海区桂城',
                    zxrs: '4人',
                    zxsysj: '02:42:18',
                    rwrq: '2018-03-30',
                    wxcd: '黄色'
                },{
                    rwmc: '千灯湖捉喵行动',
                    rwdd: '广东省佛山市南海区桂城',
                    zxrs: '4人',
                    zxsysj: '02:42:18',
                    rwrq: '2018-03-30',
                    wxcd: '黄色'
                },{
                    rwmc: '千灯湖捉喵行动',
                    rwdd: '广东省佛山市南海区桂城',
                    zxrs: '4人',
                    zxsysj: '02:42:18',
                    rwrq: '2018-03-30',
                    wxcd: '黄色'
                },{
                    rwmc: '千灯湖捉喵行动',
                    rwdd: '广东省佛山市南海区桂城',
                    zxrs: '4人',
                    zxsysj: '02:42:18',
                    rwrq: '2018-03-30',
                    wxcd: '黄色'
                },{
                    rwmc: '千灯湖捉喵行动',
                    rwdd: '广东省佛山市南海区桂城',
                    zxrs: '4人',
                    zxsysj: '02:42:18',
                    rwrq: '2018-03-30',
                    wxcd: '黄色'
                },{
                    rwmc: '千灯湖捉喵行动',
                    rwdd: '广东省佛山市南海区桂城',
                    zxrs: '4人',
                    zxsysj: '02:42:18',
                    rwrq: '2018-03-30',
                    wxcd: '黄色'
                },{
                    rwmc: '千灯湖捉喵行动',
                    rwdd: '广东省佛山市南海区桂城',
                    zxrs: '4人',
                    zxsysj: '02:42:18',
                    rwrq: '2018-03-30',
                    wxcd: '黄色'
                },{
                    rwmc: '千灯湖捉喵行动',
                    rwdd: '广东省佛山市南海区桂城',
                    zxrs: '4人',
                    zxsysj: '02:42:18',
                    rwrq: '2018-03-30',
                    wxcd: '黄色'
                },{
                    rwmc: '千灯湖捉喵行动',
                    rwdd: '广东省佛山市南海区桂城',
                    zxrs: '4人',
                    zxsysj: '02:42:18',
                    rwrq: '2018-03-30',
                    wxcd: '黄色'
                },{
                    rwmc: '千灯湖捉喵行动',
                    rwdd: '广东省佛山市南海区桂城',
                    zxrs: '4人',
                    zxsysj: '02:42:18',
                    rwrq: '2018-03-30',
                    wxcd: '黄色'
                },{
                    rwmc: '千灯湖捉喵行动',
                    rwdd: '广东省佛山市南海区桂城',
                    zxrs: '4人',
                    zxsysj: '02:42:18',
                    rwrq: '2018-03-30',
                    wxcd: '黄色'
                },{
                    rwmc: '千灯湖捉喵行动',
                    rwdd: '广东省佛山市南海区桂城',
                    zxrs: '4人',
                    zxsysj: '02:42:18',
                    rwrq: '2018-03-30',
                    wxcd: '黄色'
                },{
                    rwmc: '千灯湖捉喵行动',
                    rwdd: '广东省佛山市南海区桂城',
                    zxrs: '4人',
                    zxsysj: '02:42:18',
                    rwrq: '2018-03-30',
                    wxcd: '黄色'
                },{
                    rwmc: '千灯湖捉喵行动',
                    rwdd: '广东省佛山市南海区桂城',
                    zxrs: '4人',
                    zxsysj: '02:42:18',
                    rwrq: '2018-03-30',
                    wxcd: '黄色'
                },{
                    rwmc: '千灯湖捉喵行动',
                    rwdd: '广东省佛山市南海区桂城',
                    zxrs: '4人',
                    zxsysj: '02:42:18',
                    rwrq: '2018-03-30',
                    wxcd: '黄色'
                },{
                    rwmc: '千灯湖捉喵行动',
                    rwdd: '广东省佛山市南海区桂城',
                    zxrs: '4人',
                    zxsysj: '02:42:18',
                    rwrq: '2018-03-30',
                    wxcd: '黄色'
                },{
                    rwmc: '千灯湖捉喵行动',
                    rwdd: '广东省佛山市南海区桂城',
                    zxrs: '4人',
                    zxsysj: '02:42:18',
                    rwrq: '2018-03-30',
                    wxcd: '黄色'
                },{
                    rwmc: '千灯湖捉喵行动',
                    rwdd: '广东省佛山市南海区桂城',
                    zxrs: '4人',
                    zxsysj: '02:42:18',
                    rwrq: '2018-03-30',
                    wxcd: '黄色'
                }
            ];
        return (
            <div className="task-correction">
                <div className="page-title">任务纠错<span>Task correction</span></div>
                <div className="page-content">
                    <Table columns={columns} locale={locale} dataSource={dataSource} scroll={{y: 'calc(100% - 38px)'}} pagination={false}
                           size="small" title={() => '我参与过的任务'}/>
                </div>
            </div>
        );
    }
}

export default TaskCorrection;



// WEBPACK FOOTER //
// ./src/routes/task/TaskCorrection.jsx